const RemoveHtmlTag = async text => {
  return text.replace(/<[^>]*>/g, "");
};

export default RemoveHtmlTag;
